import React from "react";
import { Row, Col, Tabs, Tab, Form, Button } from "@themesberg/react-bootstrap";
import { SpinnerLoader } from "../../../../../components/Preloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import { DateRangePickerWithoutInput } from "../../../../../components/DateRangePicker";
import useGameReport from "../../hooks/useGameReport";
import DateOptionsFilter from "../../../../../components/DateOptionsFilter";
import GameReportTable from "../../../../../components/GameReportTable";
import { downloadFile } from "../../../../../utils/fileDownloader";
import PaginationComponent from "../../../../../components/Pagination";

export default ({ selectedPortal, selectedClient }) => {
  const {
    fetchDetails,
    setState,
    state,
    loading,
    selectedTab,
    setSelectedTab,
    gameReport,
    setDateOptions,
    dateOptions,
    getCsvDownloadUrl,
    search,
    setSearch,
    limit,
    setLimit,
    page,
    setPage,
    totalPages,
    handleResetFilters
  } = useGameReport({ selectedPortal, selectedClient });

  return (
    <>
      <Row className="align-items-center mb-3 flex-md-row flex-column">

        <Col xs={12} lg={3} className="mb-2 mb-md-0">
          <h3 className="d-flex mb-0">
            Game Report{" "}
            {loading ? (
              <SpinnerLoader />
            ) : (
              <FontAwesomeIcon
                onClick={handleResetFilters}
                style={{
                  fontSize: "15px",
                  color: "gray",
                  cursor: "pointer",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
                icon={faRedo}
              />
            )}
          </h3>
        </Col>


        <Col xs={12} lg={9}>
          <div className="d-flex flex-column flex-md-row justify-content-md-end align-items-md-center gap-2">
            <Form.Control
              type="search"
              placeholder="Search Game"
              size="sm"
              value={search}
              // style={{ maxWidth: "300px" }}
              onChange={(event) => setSearch(event.target.value)}
              className="me-md-2"
            />

            {/* Custom date range - conditionally shown */}
            {dateOptions === "custom" && (
              <div className="me-md-2">
                <DateRangePickerWithoutInput state={state} setState={setState} />
              </div>
            )}

            {/* Date Options */}
            {/* <div className="d-flex flex-column flex-md-row align-items-md-center">
              <Form.Label className="mb-1 mb-md-0 me-md-2" style={{ width: "100px" }}>
                Date Options
              </Form.Label> */}
              <div className="d-flex flex-column flex-md-row align-items-md-center">
                            <Form.Label className="mb-1 mb-md-0 me-md-2">Date Options</Form.Label>
              <DateOptionsFilter
                dateOptions={dateOptions}
                setDateOptions={setDateOptions}
              />
            </div>

            {/* Export Button */}
            <Button
              variant="outline-success"
              size="sm"
              style={{ width: "150px" }}
              disabled={gameReport?.length < 1}
              onClick={() => downloadFile(getCsvDownloadUrl("csv", "game-report"))}
            >
              Export Details
            </Button>
          </div>
        </Col>
      </Row>


      {/* <Tabs
        activeKey={selectedTab}
        onSelect={(tab) => setSelectedTab(tab)}
        className='nav-light dashboard'
      >
        <Tab eventKey='game' title='GAME'>
          <div className='mt-2'>
            <Row className='mt-3 d-flex flex-row-reverse text-right'>
            </Row>
          </div>
        </Tab>

        <Tab eventKey='provider' title='PROVIDER'>
          <div className='mt-2'>
          <Row className='mt-3 d-flex flex-row-reverse text-right'>
          <GameReportTable tableData={gameReport || []} />
          </Row>
          </div>
        </Tab>
      </Tabs> */}
      <GameReportTable tableData={gameReport?.rows || []} />
      {gameReport?.count !== 0 && !loading && (
        <PaginationComponent
          page={gameReport?.count < page ? setPage(1) : page}
          totalPages={totalPages}
          setPage={setPage}
          limit={limit}
          dontShowRow={false}
          setLimit={setLimit}
        />
      )}
    </>
  );
};
